import { fmhNpiAPI, SCOPE_ASSESSOR_API_URL } from 'api/APIBase';

/**
 * Submits a new request for a benefit check
 * @param {string} payerId
 * @param {string} segmentId
 * @param {string} memberId
 * @param {date} dateOfBirth
 * @param {string} firstName
 */
export async function submitBenefitCheckRequest({
    payerId,
    segmentId,
    memberId,
    dateOfBirth,
    firstName,
}) {
    const url = `${SCOPE_ASSESSOR_API_URL}/${payerId}/benefits/benefit-check`;
    return fmhNpiAPI({ url })
        .query({
            cardholder_id: memberId,
            date_of_birth: dateOfBirth,
            first_name: firstName,
            segment_id: segmentId,
        })
        .get()
        .json();
}
